class Gamepad
{
    public static readonly KEYS = {
        ACCELERATE: [38, 87],
        BRAKE: [40, 83],
        LEAN_LEFT: [37, 65],
        LEAN_RIGHT: [39, 68],
        RESTART: 82
    }

    private downButtons: {
        [key: string]: boolean
    }

    private tickDownButtons: {
        [key: string]: boolean
    }

    constructor()
    {
        this.downButtons = {}
        this.tickDownButtons = {};
    }

    /**
     * Sets the
     * @param keyCode
     */
    public setButtonDown(keyCode): void
    {
        this.downButtons[keyCode] = true;
    }

    /**
     * Sets gamepad button up
     * @param keyCode
     */
    public setButtonUp(keyCode): void
    {
        this.downButtons[keyCode] = false;
    }

    /**
     * Checks if button is down
     * @param keyCodes
     */
    public isButtonDown(keyCodes: number | number[]): boolean
    {
        let isDown = false;

        if (Array.isArray(keyCodes))
        {
            for (let keyCode of keyCodes)
            {
                if (this.tickDownButtons[keyCode])
                {
                    isDown = true;
                    break;
                }
            }
        }
        else
        {
            if (this.tickDownButtons[keyCodes])
            {
                isDown = this.tickDownButtons[keyCodes];
            }
        }

        return isDown;
    }

    /**
     * Updates the gamepad
     * This is required so that key downs are consistent per tick
     */
    public update(): void
    {
        this.tickDownButtons = { ...this.downButtons };
    }

    /**
     * Resets the gamepad keys
     */
    public reset(): void
    {
        this.downButtons = {};
        this.tickDownButtons = {};
    }

}

export default Gamepad;
